import {Injectable} from '@angular/core';
import {AsaxElasticService} from 'asax-elastic';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Energy, Project, Publication} from 'asax-common';

@Injectable({
  providedIn: 'root'
})
export class SearchTableCellService {
  constructor(private readonly asaxElasticService: AsaxElasticService) {
  }

  fetchProject(projectCode: string): Observable<Project> {
    return this.asaxElasticService.searchByQuery({
      index: 'projects',
      body: {
        _source: ['title', 'proposalAbstract', 'piName'],
        query: {terms: {_id: [projectCode]}}
      }
    }).pipe(
      map((data: any) => ({...data.hits.hits[0]._source}))
    );
  }

  fetchAsdms(datasetId: string): Observable<string[]> {
    return this.asaxElasticService.searchByQuery({
      index: 'observations',
      body: {
        _source: ['asdms'],
        query: {terms: {_id: [datasetId]}}
      }
    }).pipe(
      map((data: any) => data.hits.hits[0]._source.asdms)
    );
  }

  fetchObservationsForProject(projectCode: string, searchTablePage: any): Observable<any> {
    return this.asaxElasticService.searchByQuery({
      index: 'observations',
      body: {
        from: searchTablePage.from,
        size: searchTablePage.size,
        _source: searchTablePage.source,
        query: {term: {'project.code': projectCode}},
        sort: searchTablePage.sort,
      }
    }).pipe(
      map((data: any) => {
        return {
          totalRows: data.hits.total,
          rows: data.hits?.hits?.map(({_source}) => ({..._source})) || [],
          from: searchTablePage.from
        };
      })
    );
  }

  fetchObservationsForPublication(bibCode: string, searchTablePage: any): Observable<any> {
    return this.asaxElasticService.searchByQuery({
      index: 'observations',
      body: {
        from: searchTablePage.from,
        size: searchTablePage.size,
        _source: searchTablePage.source,
        query: {nested: {path: 'publications', query: {term: {'publications.bibCode': bibCode}}}},
        sort: searchTablePage.sort,
      }
    }).pipe(
      map((data: any) => {
        return {
          totalRows: data.hits.total,
          rows: data.hits?.hits?.map(({_source}) => ({..._source})) || [],
          from: searchTablePage.from
        };
      })
    );
  }

  fetchFrequency(datasetId: string): Observable<Energy[]> {
    return this.asaxElasticService.searchByQuery({
      index: 'observations',
      body: {
        _source: ['energy.freqMin', 'energy.freqMax', 'energy.resMax', 'energy.sens10', 'energy.sensBand', 'energy.polProduct', 'energy.chaNum'],
        query: {terms: {_id: [datasetId]}}
      }
    }).pipe(
      map((data: any) => data.hits.hits[0]._source.energy)
    );
  }

  fetchPublications(projectCode: string, searchTablePage: any): Observable<any> {
    return this.asaxElasticService.searchByQuery({
      index: 'publications',
      body: {
        from: searchTablePage.from,
        size: searchTablePage.size,
        _source: searchTablePage.source,
        query: {nested: {path: 'projects', query: {term: {'projects.code': projectCode}}}},
        sort: searchTablePage.sort,
      }
    }).pipe(
      map((data: any) => {
        return {
          totalRows: data.hits.total,
          rows: data.hits?.hits?.map(({_source}) => ({..._source})) || [],
          from: searchTablePage.from
        };
      })
    );
  }

  fetchPublication(bibCode: string): Observable<Publication> {
    return this.asaxElasticService.searchByQuery({
      index: 'publications',
      body: {
        _source: ['bibAbstract', 'authors', 'bibCode', 'title'],
        query: {terms: {_id: [bibCode]}}
      }
    }).pipe(
      map((data: any) => data.hits.hits[0]._source)
    );
  }

  fetchProjects(bibCode: string, searchTablePage: any): Observable<any> {
    return this.asaxElasticService.searchByQuery({
      index: 'projects',
      body: {
        from: searchTablePage.from,
        size: searchTablePage.size,
        _source: searchTablePage.source,
        query: {nested: {path: 'publications', query: {term: {'publications.bibCode': bibCode}}}},
        sort: searchTablePage.sort,
      }
    }).pipe(
      map((data: any) => {
        return {
          totalRows: data.hits.total,
          rows: data.hits?.hits?.map(({_source}) => ({..._source})) || [],
          from: searchTablePage.from
        };
      })
    );
  }
}
